import React from "react";
import Default from "./Common/Default";

const Gebruikers = () => {
    return (
        <Default />
    )
};

export default Gebruikers;